import { useMemo } from 'react'

import { ActionFlag } from '@makyoapp/makyo-common'

import { useAppBuilderContext } from '@/context/AppBuilderContext'
import { useAppOverlaysContext } from '@/context/AppOverlaysContext'

import OverlayPanelEdit from './components/PagePanel/OverlayPanelEdit'
import OverlayPanelNormal from './components/PagePanel/OverlayPanelNormal'
import PagePanelEdit from './components/PagePanel/PagePanelEdit'
import PagePanelNormal from './components/PagePanel/PagePanelNormal'

/**
 * builder leading-sidebar page panel
 */
export function PagePanel() {
  const { pages, pageAction, overlays } = useAppBuilderContext()
  const { overlayAction } = useAppOverlaysContext()

  const { curPage, curOverlay } = useMemo(() => {
    const curPage = pages?.find((p) => p.id === pageAction?.page)
    const curOverlay = overlays?.find((o) => o.id === overlayAction?.page)
    return { curPage, curOverlay }
  }, [pages, pageAction, overlays, overlayAction])

  const isEditMode = overlayAction?.flag === ActionFlag.Edit || pageAction?.flag === ActionFlag.Edit
  const hasActivePageOrOverlay = curPage || curOverlay

  const showEditPanel = isEditMode && hasActivePageOrOverlay

  const renderEditPanel = () => {
    if (!!curPage) return <PagePanelEdit key={curPage.id} page={curPage} />
    if (!!curOverlay) return <OverlayPanelEdit key={curOverlay.id} overlay={curOverlay} />
    return null
  }

  return (
    <div className='page-panel mk-builder-panel'>
      {showEditPanel ? (
        renderEditPanel()
      ) : (
        <>
          <PagePanelNormal />
          <OverlayPanelNormal />
        </>
      )}
    </div>
  )
}
